import React, { useEffect, useState, Fragment, useRef } from "react";
import { DailyTaskDetailReportTableContent } from '../../../Common/Table/tableContent';
import tokenService from '../../../../Common/tokenDecoder';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.dataOne;
        const reportData = this.props.data;
        const totalCount = this.props.totalCount;
        const contentRowNames = this.props.rowNames;
        const keys = this.props.keys;

        return (
            <div>
                <h3><center><u>Sundry / Factory Summary Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.estate}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.division == undefined ? "All Collection Points" : searchData.division}</div>
                    <div className="col"><b>Category: </b> {searchData.category == undefined ? "All Categories" : searchData.category}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>

                {keys.map((e, index) => {
                    return (
                        <div key={index} className="row pt-2">
                            <div className="col width4">
                                <TableContainer component={Paper}>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Collection Point</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Task Category</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Task</TableCell>
                                                <TableCell align="right" style={{ fontWeight: "bold" }}>Task Count</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {reportData.map((row, i) => (
                                                <TableRow key={i}>
                                                    <TableCell component="th" scope="row" align="center"> {row.collectionPointName}</TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {row.estateTaskCategory}</TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {row.taskName}</TableCell>
                                                    <TableCell component="th" scope="row" align="right"> {row.taskCount}</TableCell>

                                                </TableRow>

                                            )
                                            )}

                                        </TableBody>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}></TableCell>
                                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}></TableCell>
                                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {totalCount}</TableCell>
                                            </TableRow>

                                        </TableHead>

                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                    )
                })}
            </div>
        );
    }
}